module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1109.9e11ec0e.png";